import React from 'react';
import PropTypes from 'prop-types';
import SpotListItemBase, {
    SPOTLISTITEM_PROP_TYPES,
    SPOTLISTITEM_IMAGE_DIMENSIONS,
} from './SpotListItemBase';
import FacilitySummary from 'common/facility-details/FacilitySummary';

const SpotListItemMonthly = props => {
    const {isMobile, spot, isAdmin, isLowInventoryEnabled} = props;
    const {available_monthly_inventory: monthlyInventory} = spot;
    const {
        width: imageWidth,
        height: imageHeight,
    } = SPOTLISTITEM_IMAGE_DIMENSIONS(isMobile);

    return (
        <SpotListItemBase
            {...props}
            isSoldOut={false} // always false on monthly
            showDetailsButton={isMobile} // always true for monthly+mobile
            showBookButton={!isMobile} // true for monthly+desktop
            bypassOnBookSpotClick
            FacilitySummary={
                <FacilitySummary
                    spot={spot}
                    priceLabel="/month"
                    availableInventory={monthlyInventory?.default_rate}
                    lowInventoryThreshold={3}
                    imageWidth={imageWidth}
                    imageHeight={imageHeight}
                    isAdmin={isAdmin}
                    isLowInventoryEnabled={isLowInventoryEnabled}
                />
            }
        />
    );
};

SpotListItemMonthly.propTypes = {
    ...SPOTLISTITEM_PROP_TYPES,
    isLowInventoryEnabled: PropTypes.bool,
    isSoldOutEnabled: PropTypes.bool,
};

export default SpotListItemMonthly;
